/**
 * Mocking client-server processing
 */
import Vue from 'vue'
import {bus} from '@/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'

Vue.use(Loading)
let loader

function setApiMainPath (url) {
  localStorage.setItem('urlApi', url)
}

function showInfoDialog (mtitle, mbody, maccept, monAccept, mcancel, monCancel) {
  let msj = {
    title: mtitle,
    body: mbody,
    accept: maccept,
    cancel: mcancel,
    onAccept: monAccept,
    onCancel: monCancel
  }
  bus.$emit('showDialog', msj)
}

function getApiMainPath () {
  return localStorage.getItem('urlApi')
}

function setMainPath (url) {
  localStorage.setItem('urlAdmin', url)
}

function getMainPath () {
  return localStorage.getItem('urlAdmin')
}

function setLoading (loading) {
  localStorage.setItem('loading', loading)
}

function setToken (url) {
  localStorage.setItem('tokenAdmin', url)
}

function getToken () {
  return localStorage.getItem('tokenAdmin')
}

function setPermission (data) {
  localStorage.setItem('permission', data)
}

function getPermission () {
  return localStorage.getItem('permission')
}

function setIdUser (url) {
  localStorage.setItem('idUserAdmin', url)
}

// function getIdUser () { return localStorage.getItem('idUserAdmin') }

function showLoading () {
  if(loader){
    loader.hide()
  }
  loader = Vue.$loading.show({
    container: Vue.fullPage ? null : Vue.formContainer
  })
}

function hideLoading () {
  loader.hide()
}

function getCurrentDate () {
  const toTwoDigits = num => num < 10 ? '0' + num : num;
  let today = new Date();
  let year = today.getFullYear();
  let month = toTwoDigits(today.getMonth() + 1);
  let day = toTwoDigits(today.getDate());
  return `${year}-${month}-${day}`;
}

function getDate (myTime) {
  const toTwoDigits = num => num < 10 ? '0' + num : num;
  let today = new Date(myTime);
  let year = today.getFullYear();
  let month = toTwoDigits(today.getMonth() + 1);
  let day = toTwoDigits(today.getDate());
  return `${year}-${month}-${day}`;
}

function currencyFormat(value){
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
}

function status (response) {
  if ((response.status >= 200 && response.status < 300) || response.status == 401) {
    return Promise.resolve(response)
  } else {
    showInfoDialog('Mensaje informativo','Ocurrio un error procesando la peticion.','Aceptar')
    return Promise.reject(new Error(response.statusText))
  }
}

function fetchApi (url, data, typeMethod) {
  showLoading()
  return new Promise(function (resolve, reject) {
    if (self.fetch) {
      setLoading(true)
      // ejecutar petición fetch
      let headers = {
        'Authorization': 'Bearer ' + getToken(),
        'Content-Type': 'application/json'
      }
      let params = {
        method: typeMethod,
        cache: 'default',
        mode: 'cors'
      }
      params.headers = headers
      if (typeMethod !== 'GET') {
        params.body = data
      }
      console.log('params: ', data)
      var request = new Request(getApiMainPath() + url, params)
      fetch(request)
        .then(status)
        .then(res => res.json())
        .then((data) => {
          // console.log('Request succeeded with JSON response', data)
          console.log('Request succeeded with JSON response', JSON.stringify(data, null, 2))
          resolve(data)
          hideLoading()
        }).catch((error) => {
          console.log('Request failed', error)
          reject(Error('Request failed', error))
          hideLoading()
        })
    } else {
      // ¿hacer algo con XMLHttpRequest?
    }
  })
}

export {
  fetchApi,
  setToken,
  setIdUser,
  getMainPath,
  setApiMainPath,
  setMainPath,
  setPermission,
  getPermission,
  showInfoDialog,
  currencyFormat,
  getCurrentDate,
  getDate
}



// WEBPACK FOOTER //
// ./src/api/index.js